import useAuth from '@/auth/useAuth';
import { Button } from '@/components/ui/button';
import { useState } from 'react';
import OnBoardPayment from './OnBoardPayment';
import { useUpdateUser } from '@/service/user/hook';

const Onboard = () => {
  const { session } = useAuth();
  const email = session?.user?.email;
  const [step, setStep] = useState('welcome');
  // const name = (user?.user_metadata.full_name as string) || user?.email;

  const { mutate, isPending } = useUpdateUser();
  const handleSubmit = async () => {
    mutate({ is_onboard: false, email: email });
  };

  return (
    <div className="container mt-24 flex flex-col">
      {step === 'welcome' && (
        <div className="m-auto text-center">
          <h1 className="text-2xl font-bold">
            Welcome to <span className="text-band-blue">Float16.cloud</span>👋
          </h1>
          <div className="mt-2 flex flex-col gap-2">
            <span>
              You are signed in as <strong>{email}</strong>
            </span>
          </div>
          <Button
            className="mt-12 w-full"
            onClick={handleSubmit}
            disabled={isPending}
            // onClick={() => setStep('payment')}
          >
            Submit
          </Button>
        </div>
      )}
      {/* {step === 'payment' && (
        <div className="m-auto">
          <OnBoardPayment />
        </div>
      )} */}
    </div>
  );
};

export default Onboard;
